export function ambienteApi(hostname) {
  const host=String(hostname||'').toLowerCase();
  const desenvolvimento=['localhost','127.0.0.1','[::1]','::1'].includes(host)||host.endsWith('.localhost');
  const origem=desenvolvimento?'https://apidesenv.espacomarciobagagine.com.br':'https://api.espacomarciobagagine.com.br';
  return {desenvolvimento,origem,base:origem+'/'};
}
const ambiente=ambienteApi(typeof window!=='undefined'?window.location.hostname:'');
export const AMBIENTE_DESENVOLVIMENTO=ambiente.desenvolvimento;
export const API_ORIGEM=ambiente.origem;
export const API_BASE_URL=ambiente.base;
export const apiUrl=caminho=>API_BASE_URL+String(caminho||'').replace(/^\/+/, '');
